export default "__VITE_ASSET__CJzYuYdJ__"